module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Images from reviews'
    };
    return resources[label];
};
